import Footer from "./partials/Footer";
import Header from "./partials/Header";
import Base from "./Base";
import Login from "./partials/Login";
import Register from "./partials/Register";
import RegisterSocialMedia from "./partials/RegisterSocialMedia";
import ForgetPassword from "./partials/ForgetPassword";
import { Context } from "../Context";
import { destroyCookie } from "nookies";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

const CountryLayout = () => {
  const navigate = useNavigate();

  const [context, setContext] = useContext(Context);

  const logout = (e) => {
    e.preventDefault();
    destroyCookie(null, 'NrisToken', {
      path: '/',
      domain: '.nris.com',
    });
    
    destroyCookie(null, 'NrisUser', {
      path: '/',
      domain: '.nris.com',
    });

    localStorage.removeItem("__nristoken");
    localStorage.removeItem("__nrisuser");

    destroyCookie(null, "NrisToken", { path: "/" });
    destroyCookie(null, "NrisUser", { path: "/" });

    setContext((prevValue) => ({
      ...prevValue,
      user: "",
      userToken: "",
    }));

    window.$("#inactiveSessionModal").modal("hide");
    navigate("/");
  };

  return (
    <>
      <Header />
      <main className="main">
        <Base />
      </main>
      <Footer />
      <Login />
      <Register />
      <RegisterSocialMedia />
      <ForgetPassword />
      <div
        className="modal fade pe-0"
        id="inactiveSessionModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header d-block text-center border-bottom-0">
              <h5 className="text-brand-1">
                You have been inactive for more than 45 minutes. Please login
                again
              </h5>
            </div>
            <div className="modal-body px-4 pb-4">
              <div className=" d-block text-center mt-2 mb-3">
                <button
                  className="btn btn-danger hover-up m-auto me-2"
                  type="button"
                  onClick={logout}
                  style={{ padding: "7px 15px", lineHeight: "19px" }}
                >
                  ok
                </button>
                <button
                  className="btn btn-default hover-up m-auto"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => window.$("#loginModal").modal("show")}
                >
                 Re-login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CountryLayout;
